import isUndefined from 'lodash/isUndefined';
import { useCallback } from 'react';

import { useAnalytics } from 'applications/GSP/shared/hooks/analytics';
import { useAppSelector } from 'applications/GSP/shared/hooks/store';
import { useMediaQuery } from 'shared/hooks/dom';

import { SidebarDesktop } from './components/SidebarDesktop';
import { SidebarMobile } from './components/SidebarMobile';
import { useNavigationItems } from './hooks';

import type { AnalyticsEvent } from 'applications/GSP/shared/constants/analytics';
import type { FC } from 'react';

export const Sidebar: FC = () => {
  const { opened } = useAppSelector(state => state.sidebar);
  const matches = useMediaQuery('md');
  const analytics = useAnalytics();
  const navigationItems = useNavigationItems();

  const onActive = useCallback(
    (analyticsEvent: AnalyticsEvent) => {
      analytics.track(analyticsEvent);
    },
    [analytics],
  );

  if (isUndefined(opened)) return null;

  return matches ? (
    <SidebarDesktop navigationItems={navigationItems} onActive={onActive} />
  ) : (
    <SidebarMobile navigationItems={navigationItems} onActive={onActive} />
  );
};
